import {
  Grid,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
// import { InsurancePatientType, PatientFullDetailsType } from "../../PatientBooking/types";
import { useFetchPatientDetailsByEMR } from "../../../../../PatientCare/hookv2/apiHooks";
import {
  InsurancePatientType,
  PatientFullDetailsType,
} from "../../../../../PatientCare/PatientBooking/v2/types";
import moment from "moment";
import { getPatientGroupingDisplay } from "../../../../../utilis/methods/patientGrouping";
import PatientVipChip from "../../../../../utilis/component/PatientVipChip";
// import useAuthentication from "@hooks/useAuthentication";

const DetailsCard = ({setDetails}: {setDetails?:Dispatch<SetStateAction<PatientFullDetailsType | null>>}) => {
  const navigateTo = useNavigate();
  const { encounterId } = useParams() as { encounterId: string };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [patientData, setPatientData] =
    useState<PatientFullDetailsType | null>();
  const { mutate: getPatientData } = useFetchPatientDetailsByEMR({
    onSuccess: (result) => {
      setPatientData(result.response);
      if(setDetails){
        setDetails(result.response);
      }
    },
  });
  // const {mutate:getPatientData} = useMutation(getPatientDetails,{
  //    onSuccess:(result)=>{
  //     console.log("in side-----------> result",result.response);
  //     setPatientData(result.response);
  //    }
  // })
  const goBack = () => {
    navigateTo(-1);
  };

  useEffect(() => {
    const emrNo = (queryParams.get("emrno") || "") as string;
    getPatientData({ emrNo, encounterId: parseInt(encounterId || "0") });
  }, []);

  //   const{user}= useAuthentication();
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates Id";
  
  const idHeading = "Civil ID";

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={
          <div>
            <ExpandMoreIcon />
          </div>
        }
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{ px: 1, py: 0 }}
      >
        <div className="flex gap-1 items-center">
          <IconButton color="primary" onClick={goBack}>
            <ArrowBackIcon />
          </IconButton>
          <Typography component="span" fontWeight={600}>
            Patient details
          </Typography>
          <PatientVipChip isVip={patientData?.pmaster?.isVip} />
        </div>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>
        <div
          style={{
            borderRadius: 2,
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                EMR No/Reg No
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster?.patientId || ""}
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Patient Name
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster?.patientName || ""}
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Visit No
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.encounter?.encounterId || ""}
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Contact No
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.amaster?.mobileNo || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Nationality
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.amaster?.countryName || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Gender
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster?.gender || ""}
              </Typography>
            </Grid>

            {/* Row 2 */}
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {idHeading}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster?.emiratesId || patientData?.pmaster?.gccId || patientData?.pmaster?.passportNum}
              </Typography>
            </Grid>
            {/* <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Passport ID
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster.passportNum || ""}
              </Typography>
            </Grid> */}
            {/* <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                GCC ID
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {patientData?.pmaster?.gccId || ""}
              </Typography>
            </Grid> */}
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Insurance Type
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.insurancetype_name || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Insurance Plan
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.inPlan_name || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Insurance Name
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.insurance_name || ""}
              </Typography>
            </Grid>

            {/* Row 3 */}
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Insurance Group
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.inGroup_name || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Member Id
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.policyNo || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Expiry Date
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {(patientData?.insurancePatient as InsurancePatientType)
                  ?.policyValidity
                  ? moment(
                    (patientData?.insurancePatient as InsurancePatientType)
                      ?.policyValidity
                  ).format("DD-MM-YYYY")
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Grouping
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {getPatientGroupingDisplay(patientData) || "-"}
              </Typography>
            </Grid>
           
          </Grid>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default DetailsCard;
